import { Inject, Injectable, LOCALE_ID } from '@angular/core';

import { Product, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ProductService } from '../service/product.service';
import { ProductActions } from './products.actions';

@Injectable()
export class ProductsEpics implements RidangoEpic {
    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private actions: ProductActions,
        private service: ProductService
    ) {}

    register() {
        return [this.fetchProductsByChannel];
    }

    fetchProductsByChannel = (action$: ActionsObservable<any>) =>
        action$.ofType(ProductActions.FETCH_PRODUCTS).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { channel, isWalletType } = action.payload;
                return this.service.fetchProductsByChannel(channel).pipe(
                    map((products) => {
                        return this.setProducts(this.updateProductProperties(products));
                    }),
                    catchError((error) => of(this.actions.fetchProductsFail(error)))
                );
            })
        );

    private updateProductProperties(products: Product[]) {
        const updatedProducts = products.map((product) => {
            product.display = '-';
            if (product.name) {
                product.display = product.name;
            }
            if (product.translations && product.translations.find((t) => t.lang === this.locale)) {
                product.display = product.translations.find((t) => t.lang === this.locale).translation;
            }
            return product;
        });

        return updatedProducts;
    }

    private setProducts(products: Product[]) {
        let normalized = {};
        let byId = {};
        let allIds = [];
        let fixedSumProductIds = [];
        let variableSumProductId = null;

        // products.forEach((p) => {
        //     normalized[p.product_id] = p;
        //     allIds.push(p.product_id);
        // });
        normalized = products.reduce((acc, val) => {
            return { ...acc, [val.product_id]: val };
        }, {});
        byId = products.reduce((acc, val) => {
            return { ...acc, [val.product_id]: val };
        }, {});

        allIds = products.map((p) => p.product_id);

        // set fixed sum products
        const fixedSumProducts = products.filter(
            (product) =>
                product.product_type === 'W' &&
                (!product.product_properties ||
                    product.product_properties.filter(
                        (p) => p.code === 'LOAD_WALLET_MIN' || p.code === 'LOAD_WALLET_MAX' || p.code === 'MANUAL_PRICE'
                    ).length === 0)
        );
        fixedSumProductIds = fixedSumProducts.map((p) => p.product_id);

        // set variable products
        const variableSumProduct = products.find(
            (product) =>
                product.product_properties.filter((p) => p.code === 'LOAD_WALLET_MIN' || p.code === 'LOAD_WALLET_MAX')
                    .length > 0
        );
        variableSumProductId = variableSumProduct && variableSumProduct.product_id;

        const payload = {
            products: products,
            normalized: normalized,
            byId: byId,
            allIds: allIds,
            fixedSumProductIds: fixedSumProductIds,
            variableSumProductId: variableSumProductId
        };

        return this.actions.setProducts(payload);
    }
}
